export default __webpack_public_path__ + "static/media/colors-000.6eb9dde3.png";